import React from 'react'
import { InputAdornment, Typography, useTheme } from '@mui/material'

interface StyledInputAdornmentProps {
  text?: string
  position?: 'start' | 'end'
  fontsize?: string
}

const StyledInputAdornment = ({ text = '$', position = 'start', fontsize = '0.8rem' }: StyledInputAdornmentProps) => {
  const theme = useTheme()
  return (
    <InputAdornment position={position}>
      <Typography sx={{ color: theme.palette.text.secondary, fontSize: fontsize }}>{text}</Typography>
    </InputAdornment>
  )
}

export default StyledInputAdornment
